import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.common.white};
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    margin-bottom: 4px;
  }

  p {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const GridHeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const CategorySection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.divider};

  &:first-of-type {
    border-top: none;
  }
`;

export const CategoryHeaderRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const CategoryInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CategoryTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CategoryLabel = styled.label`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 500;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
  cursor: pointer;
`;

export const CategoryDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const WorkflowsContainer = styled.div`
  background: ${({ theme }) => theme.palette.action.hover};
`;

export const WorkflowRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 20px 8px 52px;

  &:last-child {
    padding-bottom: 12px;
  }
`;

export const WorkflowCell = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const WorkflowTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const WorkflowLabel = styled.label`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const WorkflowDescription = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
`;

export const ChannelHeaderCell = styled.div`
  width: 100px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
  font-weight: 500;
`;

export const ChannelCell = styled.div`
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderSpacer = styled.div`
  flex: 1;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  width: 100%;
`;
